import angular from 'angular'

import contactAsk from './services/ask.service'
import contactData from './services/data.service'
import contactFormat from './services/format.service'
import contactGo from './services/go.service'
import contactLocal from './services/local.service'
import contactMetadata from './services/metadata.service'
import contactRequest from './services/request.service'
import contactResource from './services/resource.service'
import contact from './services/contact.service'
import myContactsForm from './directives/form/myContactsForm'
import myContactForm from './directives/form/myContactForm'
import myContactsDisplay from './directives/display/myContactsDisplay'
import myContactDisplay from './directives/display/myContactDisplay'

import contactIcons from './resources/icons.resource'
import contactFields from './resources/fields.resource'
import contactLabels from './resources/labels.resource'

const name = 'contact'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('contactAsk', contactAsk)
  .factory('contactData', contactData)
  .factory('contactFormat', contactFormat)
  .factory('contactGo', contactGo)
  .factory('contactLocal', contactLocal)
  .factory('contactMetadata', contactMetadata)
  .factory('contactRequest', contactRequest)
  .factory('contactResource', contactResource)
  .factory('$$contact', contact)
  // ===== DRIECTIVES ===== //
  .directive('myContactsForm', myContactsForm)
  .directive('myContactForm', myContactForm)
  .directive('myContactsDisplay', myContactsDisplay)
  .directive('myContactDisplay', myContactDisplay)
  // ===== RESOURCES ===== //
  .factory('contactFields', contactFields)
  .factory('contactIcons', contactIcons)
  .factory('contactLabels', contactLabels)

export default 'contact'



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/contact.module.js